function currency(value?: number) {
  return (value ?? 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

function measure(value?: number) {
  return (value ?? 0).toLocaleString('pt-BR', { minimumFractionDigits: 3 });
}

const formatHelper = {
  currency,
  measure,
};

export default formatHelper;
